module.exports = __webpack_public_path__ + "static/media/whitePlus.f92ac01a.svg";